import { render, staticRenderFns } from "./BrandBasilur.vue?vue&type=template&id=ec3e9e1e&scoped=true&"
import script from "./BrandBasilur.vue?vue&type=script&lang=js&"
export * from "./BrandBasilur.vue?vue&type=script&lang=js&"
import style0 from "./BrandBasilur.vue?vue&type=style&index=0&id=ec3e9e1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3e9e1e",
  null
  
)

export default component.exports